module.exports = __webpack_public_path__ + "img/icon_01.095c5233.svg";